import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { EmailPass } from '@/generated/api';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import SBSection from '@/components/SBSection.vue';
import SBKurukuru from '@/components/SBKurukuru.vue';
import SBSubTitle from '@/components/SBSubTitle.vue';
import SBText from '@/components/SBText.vue';
import SBSignUpForm from '@/components/SBSignUpForm.vue';
import SBTextbox from '@/components/SBTextbox.vue';
import SBButtonSmall from '@/components/SBButtonSmall.vue';
import SBButtonSmallGray from '@/components/SBButtonSmallGray.vue';

@Component({
    components: {
        SBSection,
        SBKurukuru,
        SBSubTitle,
        SBText,
        SBSignUpForm,
        SBTextbox,
        SBButtonSmall,
        SBButtonSmallGray,
    }
})
export default class Login extends Mixins(CommonView) {

    public url: string = "";
    public error: string = "";

    public async created() {
        if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === "string") {
            this.url = this.$route.query.url;
        } else {
            this.url = "/";
        }
        await this.getUserAPI();
        if (this.loginStatus != null && this.loginStatus.securitySafe) {
            this.$router.push(this.url);
        }
    }

    public emailPass: EmailPass = { email: "", pass: "" };
    public kurukuru: boolean = false;

    public async login() {
        this.kurukuru = true;
        let login = await SBAPI.LoginController.emailLoginUsingPOST(this.emailPass).catch(AxiosErrorHandler);
        if (isAxiosError(login)) {
            this.error = "" + login.data;
        } else {
            await this.getUserAPI();
            this.$router.push(this.url);
        }
        this.kurukuru = false;
    }
}
